export default __webpack_public_path__ + "static/media/brainhive.7977a975.svg";